import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Routes, matchPath } from 'react-router-dom-v5-compat';

import { getSecuredRoutesForUserPermissions } from '~/app/routes/routes-utils';
import { getUserPermissions } from '~/utils/permissions-helper/permissions-helper';
import { getUserRoles } from '~/utils/roles-helper/roles-helper';
import type { AppState } from '~/reducers';
import ErrorText from '~/components/views/common/ErrorText/ErrorText';
import ErrorBoundary from '~/core/components/ErrorBoundary/ErrorBoundary';

const NativeSwitch = () => {
  const activeRoutePath = useSelector((state: AppState) => state.native.activeRoutePath);
  const userRoles = getUserRoles();
  const permissions = getUserPermissions();
  const permittedRoutes = getSecuredRoutesForUserPermissions(userRoles, permissions);

  const activeRoute = permittedRoutes.componentRoutes.find((r) =>
    matchPath(r.path as string, activeRoutePath)
  );

  if (!activeRoute) {
    return (
      <ErrorText
        error={{
          description: `Feature not yet supported ${activeRoutePath}`,
        }}
      />
    );
  }
  return (
    <Routes>
      <Route
        path="/*"
        element={
          <ErrorBoundary>
            <activeRoute.Component />
          </ErrorBoundary>
        }
      />
    </Routes>
  );
};

export default NativeSwitch;
